import { Popup } from 'devextreme-react/popup';
import { useCallback, useState, useMemo, useEffect, useRef } from 'react';
import { useAppSelector, useAppDispatch } from '../../../contexts/hooks';
import { shallowEqual } from 'react-redux';
import Order from '../Components/Orders';
import Patient from '../Components/Patient';
import { clearPatient, setData, setLoading, setMode } from '../../../contexts/slices/preorders';
import { Button, DataGrid, Form, LoadIndicator, Tabs, Tooltip } from 'devextreme-react';
import { Column, Editing, Item, Toolbar } from 'devextreme-react/data-grid';
import { newToast, LabRefChip } from '../../../components';
import '../Preorders.scss';
import { useApiPatient } from '../../../api/api.patient';
import { CustomFilters, TypeTableFilter } from '../../../types/types.system';
import { useApiPreorders } from '../../../api/api.Preorders';
import { useApiConfiguration } from '../../../api/api.configuration';
import { FacturacionTarifas } from '../../../types/types.facturacion';
import { formatNumber } from 'devextreme/localization';
import { Disccount } from '../../../images/icons';
import { useScreenSize } from '../../../utils/media-query';
import { ButtonItem, Label, SimpleItem } from 'devextreme-react/form';
import { SysI_CodBarrasImpresoras } from '../../../types/types.barcodes';
import { useApiBarcodes } from '../../../api/api.barcodes';
import { setModalBarcodePrintersVisible } from '../../../contexts/slices/config';
import { useApiOrders } from '../../../api/api.orders';
import { NotesPreorders } from '../Components/Notes';
import { Notas } from '../../../types/types.preorders';
import { PreorderStudiesSearchSelect, PreorderStudyItem } from './components';
import { useApiFunctionsResult } from '../../../components/library/info-order/OrderModules/Functions/Results';

type PopupProps = {
  visible: boolean;
  wrapperAttr?: { class: string };
  setVisible: (update: boolean) => void;
  currentData?: any[];
  idPreOrder?: number;
  setCurrentPreOrderCreated?: (id: number) => void;
  idPatient?: number;
};

type discounttp = {
  type: 'value' | 'percentage' | null;
  value: number;
};
const discount: discounttp = { type: null, value: 0 };

const Index = ({ visible, setVisible, wrapperAttr = { class: '' }, currentData, idPreOrder, setCurrentPreOrderCreated, idPatient }: PopupProps) => {
  const ColumnsContainerOrderOrders = useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ColumnsContainerOrderOrders')[0], shallowEqual)?.Cgn_Resultado;
  const ColumnsContainerPatientOrders = useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ColumnsContainerPatientOrders')[0], shallowEqual)?.Cgn_Resultado;
  const CreateOrderAutomaticInPreorder: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'CreateOrderAutomaticInPreorder')[0].Cgn_Resultado) || 'false');
  const AutomaticBarcodePrint: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'AutomaticBarcodePrint')[0])?.Cgn_Resultado || 'false');
  const ModuleBarcode: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ModuleBarcode')[0].Cgn_Resultado) || 'false');
  const Prm_Preordenes_Notas_R = useAppSelector((x) => x.userInfo.Permissions?.Prm_Preordenes_Notas_R);
  const mode = useAppSelector((x) => x.globalPreOrder.Mode);
  const modePatient = useAppSelector((x) => x.globalOrders.CurrentOrder.ModePatient);
  const { handlePrintBarcodesLabel } = useApiFunctionsResult();
  const dataGridRef = useRef<DataGrid>(null);
  const [itemsAdded, setItemsAdded] = useState<FacturacionTarifas[]>([]);
  const [listsData, setListsData] = useState<string[]>(['Estudios']);
  const [modalDiscountVisible, setModalDiscountVisible] = useState(false);
  const Prm_CodBarImprimir = useAppSelector((x) => x.userInfo.Permissions?.Prm_CodBarImprimir);
  const PreorderData = useAppSelector((x) => x.globalPreOrder.PreOrder);
  const PatientData = useAppSelector((x) => x.globalPreOrder.PatientData);
  const { GetTarifasByIdContratoWithStudies } = useApiConfiguration();
  const [lstTarifas, setLstTarifas] = useState([]);
  const { NewOrderFromPreOrders } = useApiOrders();
  const idPrRedx = useAppSelector((x) => x.globalPreOrder.PreOrder?.POrd_Id); //Usado para las notas unicamente
  const [loadingNotes, setLoadingNotes] = useState(false);
  const { isSmall, isXSmall } = useScreenSize();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const frmRef = useRef<Form>(null);
  const [currentNotes, setCurrentNotes] = useState<Notas[]>([]);
  const [currentPrinter, setCurrentPrinter] = useState<SysI_CodBarrasImpresoras | undefined>(undefined);
  const { getPrinters } = useApiBarcodes();
  const cmbLabRef = useAppSelector((x) => x.configuration.Data?.LabReferencia) || [];

  // Dentro de tu componente
  const [totals, setTotals] = useState({
    subtotal: 0,
    discount: 0,
    total: 0,
  });

  const { Create, Edit, GetById, GetNotes } = useApiPreorders();
  const dispatch = useAppDispatch();
  const [loadingPac, setLoadingPac] = useState(false);
  const { findUser } = useApiPatient();

  const fetchDataNotes = useCallback(async () => {
    if (Prm_Preordenes_Notas_R && idPreOrder) {
      setLoadingNotes(true);
      const res = await GetNotes(idPreOrder);
      setCurrentNotes(res);
      setLoadingNotes(false);
    }
  }, [setCurrentNotes, GetNotes]);

  const updateNotes = (boolean: boolean) => {
    if (boolean) {
      fetchDataNotes();
    }
  };

  const onCancelClick = () => {
    dispatch(clearPatient());
    dispatch(setMode({ mode: 'view' }));
    setVisible(false);
  };

  // Cargar los datos de las impresoras al iniciar el componente
  useEffect(() => {
    getPrinterInfo();
  }, []);

  const getPrinterInfo = async () => {
    if (!ModuleBarcode) {
      return;
    }
    //Verificar si tenemos en localStorage una impresora configurada.
    const printerData = localStorage.getItem('defaultPrinter');
    let printer: SysI_CodBarrasImpresoras | undefined;
    if (printerData) {
      printer = JSON.parse(printerData);
      setCurrentPrinter(printer);
    } else {
      const printers = await getPrinters();
      if (printers?.length === 0) {
      } else if (printers?.length === 1) {
        localStorage.setItem('defaultPrinter', JSON.stringify(printers[0]));
        printer = printers[0];
        setCurrentPrinter(printer);
        newToast('INFO', `Se ha establecido la impresora '${printer.Cbp_Nombre}' como predeterminada.`, 5);
      } else {
        if (Prm_CodBarImprimir) {
          dispatch(setModalBarcodePrintersVisible(true));
        }
      }
    }
  };

  // Cargar las notas al abrir el modal
  useEffect(() => {
    if (Prm_Preordenes_Notas_R && mode !== 'new' && visible) {
      setListsData(['Estudios', 'Notas']);
      if ((idPrRedx && idPrRedx > 0) || idPreOrder) {
        fetchDataNotes();
      }
    }
  }, [visible]);

  //Actualizar totales cada que se agregue un nuevo item
  useEffect(() => {
    updateTotals();
  }, [itemsAdded]);

  // Para consultar los datos del paciente al abrir el modal
  useEffect(() => {
    if (mode !== 'new' && PreorderData && PreorderData.POrd_Pc_Id && modePatient === 'view') {
      const filters: CustomFilters[] = [{ Field: 'Pc_Id', Value: PreorderData.POrd_Pc_Id, TypeFilter: TypeTableFilter.Equal }];
      findUser(filters, setLoadingPac, true, 'preorders');
    }
  }, [PreorderData]);

  // Cargar las tarifas del contrato seleccionado
  useEffect(() => {
    if (PreorderData.POrd_Cn_Id && PreorderData.POrd_Cn_Id > 0) {
      GetTarifasByIdContratoWithStudies(PreorderData.POrd_Cn_Id).then((res) => {
        setLstTarifas(res);
        if (mode !== 'view') {
          // Ahora no quiero limpiar los items sino que si hay un contrato nuevo deseo comparar los estudios agregados y cambiarles la tarifa y sino existe en el nuevo contrato, ponerlo con tarifa 0
          setItemsAdded(
            itemsAdded.map((item) => {
              const newTarifa = res.find((t) => t.Tf_Es_Id === item.Tf_Es_Id);
              return {
                ...item,
                Tf_Valor: newTarifa ? newTarifa.Tf_Valor : 0,
              };
            })
          );
        }
      });
    }
  }, [PreorderData.POrd_Cn_Id]);

  // Limpiar los datos al cerrar la modal o al crear una nueva preorden
  useEffect(() => {
    if ((visible && mode === 'new') || !visible) {
      if (idPatient && idPatient > 0) {
        const filters: CustomFilters[] = [{ Field: 'Pc_Id', Value: idPatient, TypeFilter: TypeTableFilter.Equal }];
        findUser(filters, setLoadingPac, true, 'preorders');
      }
      //Limpiar los tipos de descuento
      discount.type = null;
      discount.value = 0;
      setItemsAdded([]);
      frmRef.current?.instance?.resetValues();
    }
  }, [visible]);

  // Este efecto es usado unicamente para visualizar la preorden desde otros modulos como Citas, Cotizaciones, etc.....
  useEffect(() => {
    if (idPreOrder && idPreOrder > 0 && visible) {
      dispatch(setMode({ mode: 'view', idPreOrder: -1 }));
      GetById(idPreOrder).then((res) => {
        if (res) {
          const data = res.Detalle.map((x) => {
            return { ...x, Tf_Valor: x.Rpre_ValUnitario, Tf_Es_Id: x.Rpre_Es_Id };
          });
          setItemsAdded(data);
          //Eliminamos el detalle de res
          res.Detalle = undefined;
          dispatch(setData(res));
          //Asignamos los datos a los descuentos aplicados
          if (res.POrd_TipoDescuento && res.POrd_TipoDescuentoValor) {
            discount.type = res.POrd_TipoDescuento === 1 ? 'percentage' : 'value';
            discount.value = res.POrd_TipoDescuentoValor;
            frmRef.current?.instance?.updateData('type', discount.type);
            frmRef.current?.instance?.updateData('value', discount.value);
          }
        }
      });
    }
  }, [idPreOrder, visible]);

  // // Este efecto es usado unicamente para visualizar la preorden desde el modulo de Preordenes
  // useEffect(() => {
  //   if (visible && mode === 'view' && currentData && !idPreOrder) {
  //     let data;
  //     data = currentData.map((x) => {
  //       return { ...x, Tf_Valor: x.Rpre_ValUnitario, Tf_Es_Id: x.Rpre_Es_Id };
  //     });

  //     setItemsAdded(data);

  //     if (PreorderData.POrd_TipoDescuento && PreorderData.POrd_TipoDescuentoValor) {
  //       frmRef.current?.instance?.updateData('type', PreorderData.POrd_TipoDescuento === 1 ? 'percentage' : 'value');
  //       frmRef.current?.instance?.updateData('value', PreorderData.POrd_TipoDescuentoValor);
  //       discount.type = PreorderData.POrd_TipoDescuento === 1 ? 'percentage' : 'value';
  //       discount.value = PreorderData.POrd_TipoDescuentoValor;
  //     } else {
  //       frmRef.current?.instance?.resetValues();
  //       discount.type = null;
  //       discount.value = 0;
  //     }
  //   }
  // }, [PreorderData]);

  // Handler para selección de estudio con nuevo componente
  const handleStudySelected = useCallback(
    (study: PreorderStudyItem) => {
      try {
        // Verificar si el estudio ya está agregado
        const isAlreadyAdded = itemsAdded.some((item) => item.Tf_Es_Id === study.Tf_Es_Id);

        if (isAlreadyAdded) {
          newToast('WARNING', `El estudio '${study.name}' ya está agregado`, 3);
          return;
        }
        // Crear el item para agregar al grid
        const newItem: FacturacionTarifas = {
          Tf_Id: 0, // Nuevo item
          Tf_Cn_Id: PreorderData.POrd_Cn_Id || 0,
          Tf_Es_Id: study.Tf_Es_Id,
          Tf_Valor: study.Tf_ValorTarifa || study.price || 0,
          Tf_Estado: true,
          Estudio: {
            Es_Id: study.Tf_Es_Id,
            Es_Aa_Id: 0,
            Es_Pd_Id: 0,
            Es_Lr_Id: study.labref,
            Es_Codigo: study.Tf_Es_Codigo,
            Es_Nombre: study.Tf_Es_Nombre,
            Es_Abreviatura: '',
            Es_Homologacion: null,
            Es_Descripcion: null,
            Es_Tecnica: null,
            Es_OrdenImpresion: 0,
            Es_Confidencial: false,
            Es_Estado: true,
            Es_TiempoDescarte: null,
            Es_CodigoCups: null,
            SysA_AreasAnalisis: study.Tf_Aa_Nombre
              ? {
                  Aa_Id: 0,
                  Aa_Nombre: study.Tf_Aa_Nombre,
                  Aa_OrdenImpresion: 0,
                  Aa_Estado: true,
                }
              : null,
            SysI_Prioridades: null,
          },
        };

        // Agregar el item al array
        setItemsAdded((prev) => [...prev, newItem]);
        newToast('SUCCESS', `Estudio '${study.name}' agregado a la preorden`, 3);
      } catch (error) {
        console.error('Error adding study to preorder:', error);
        newToast('ERROR', 'Error al agregar el estudio a la preorden', 3);
      }
    },
    [itemsAdded, PreorderData.POrd_Cn_Id]
  );

  // Convertir estudios agregados a formato para evitar duplicados
  const addedStudiesAsItems = useMemo((): PreorderStudyItem[] => {
    return itemsAdded.map((item) => ({
      id: item.Tf_Es_Id,
      code: item.Estudio?.Es_Codigo || '',
      name: item.Estudio?.Es_Nombre || '',
      group: item.Estudio?.SysA_AreasAnalisis?.Aa_Nombre || 'Sin Área',
      price: item.Tf_Valor,
      // Campos adicionales específicos
      Tf_Es_Id: item.Tf_Es_Id,
      Tf_Es_Codigo: item.Estudio?.Es_Codigo || '',
      Tf_Es_Nombre: item.Estudio?.Es_Nombre || '',
      Tf_Aa_Nombre: item.Estudio?.SysA_AreasAnalisis?.Aa_Nombre || '',
      Tf_ValorTarifa: item.Tf_Valor,
    }));
  }, [itemsAdded]);

  const calculateSubtotal = () => {
    // Calcular el subtotal sumando todos los valores de la columna Tf_Valor
    return itemsAdded.reduce((acc, item) => acc + item.Tf_Valor, 0);
  };

  const updateTotals = () => {
    const subtotal = calculateSubtotal();
    const discountAmount = calculateDiscount(subtotal);
    const total = calculateTotal(subtotal, discountAmount);

    // Actualizar el estado con los nuevos valores
    setTotals({
      subtotal: subtotal,
      discount: discountAmount,
      total: total,
    });
  };

  const calculateDiscount = (subtotal: number) => {
    // Calcular el descuento sobre el subtotal
    //return subtotal * (discount / 100);
    if (discount.type && discount.value > 0) {
      if (discount.type === 'percentage') {
        return subtotal * (discount.value / 100);
      }
      return discount.value;
    }
    return 0;
  };

  const calculateTotal = (subtotal: number, discount: number) => {
    // Calcular el total: subtotal - descuento
    return subtotal - discount;
  };

  const handleClicSave = useCallback(() => {
    if (mode !== 'view' && itemsAdded.length === 0) {
      newToast('WARNING', 'Debe agregar al menos un estudio', 5);
      return;
    }

    const PreOrdData = {
      POrd_Pc_Id: PatientData.Pc_Id,
      POrd_Cn_Id: PreorderData.POrd_Cn_Id,
      POrd_Se_Id: PreorderData.POrd_Se_Id,
      POrd_SubTotal: totals.subtotal,
      POrd_ValorTotal: totals.total,
      POrd_Descuento: totals.discount,
      POrd_TipoDescuento: discount.type === 'percentage' ? 1 : discount.type === 'value' ? 2 : null,
      POrd_TipoDescuentoValor: discount.value,
      POrd_CamposDinamicos: JSON.stringify(PreorderData.AditionalFields),
      Detalle: itemsAdded.map((x) => {
        return { Rpre_Es_Id: x.Tf_Es_Id, Rpre_ValUnitario: x.Tf_Valor, Rpre_Cantidad: 1 };
      }),
    };

    dispatch(setLoading(true));

    switch (mode) {
      case 'new':
        Create(PreOrdData)
          .then(async (x) => {
            if (x && x.POrd_Id) {
              setCurrentPreOrderCreated?.(x.POrd_Id);
              if (CreateOrderAutomaticInPreorder) {
                // crear un array llamado newItems con los items agregados, x es un solo objeto
                const newItems = [x];
                const SendData = {
                  PreOrders: newItems,
                  IdPrinter: currentPrinter?.Cbp_Id,
                };
                var result = await NewOrderFromPreOrders(SendData);
                if (result && result.length > 0) {
                  newToast('SUCCESS', `Se ha creado la orden '${result[0].OrderNumber}'`, 5);
                  if (result && AutomaticBarcodePrint) {                    
                    handlePrintBarcodesLabel(result[0].IdOrder);
                  }
                } else {
                  newToast('ERROR', 'No se pudo crear la orden desde la preorden', 5);
                }
              }
            }
          })
          .finally(() => {
            dispatch(setLoading(false));
            setVisible(true);
          });
        break;
      case 'update':
        // Actualizar cotización
        Edit(PreOrdData, PreorderData.POrd_Id).finally(() => {
          dispatch(setLoading(false));
          setVisible(true);
        });
        break;
      default:
        dispatch(setLoading(false));
        break;
    }
  }, [itemsAdded, PreorderData, PatientData, mode, totals]);

  const handleAddDiscount = useCallback(() => {
    if (mode === 'view') {
      return;
    }
    setModalDiscountVisible(true);
  }, [setModalDiscountVisible, mode]);

  const hanAddDiscountConfirm = useCallback(
    (e: { preventDefault: () => void }) => {
      updateTotals();
      setModalDiscountVisible(false);
      e.preventDefault();
    },
    [setModalDiscountVisible, updateTotals]
  );

  const onCancelModalDiscountClick = useCallback(() => {
    setModalDiscountVisible(false);
  }, [setModalDiscountVisible]);

  const onTabClick = useCallback((e) => {
    const current = e.itemData;
    setSelectedIndex(current === 'Estudios' ? 0 : 1);
  }, []);

  const renderTab = (item) => {
    if (item === 'Notas') {
      return (
        <span style={{ display: 'inline-flex', alignItems: 'center' }}>
          Notas
          {loadingNotes ? (
            <span style={{ marginLeft: '8px', display: 'flex', alignItems: 'center', height: '100%' }}>
              <LoadIndicator width={15} height={15} />
            </span>
          ) : (
            currentNotes?.length > 0 && (
              <span className='badge-tab' style={{ marginLeft: '5px' }}>
                {currentNotes?.length}
              </span>
            )
          )}
        </span>
      );
    }
    return <span>{item}</span>;
  };

  // Función para renderizar el chip de laboratorio de referencia
  const renderLabRefChip = ({ data }: any) => {
    return <LabRefChip labRefId={data.Estudio?.Es_Lr_Id} labRefData={cmbLabRef} size='small' opacity={0.9} />;
  };

  return (
    <div>
      <Popup title={mode === 'new' ? 'Nueva preorden' : mode === 'update' ? 'Actualizar preorden' : 'Ver preorden'} visible={visible} showCloseButton={true} onHiding={onCancelClick} wrapperAttr={{ ...wrapperAttr, class: `${wrapperAttr?.class} form-popup` }} height='98%' width={'98%'}>
        <div className='view-wrapper view-wrapper-contact-details'>
          <div className='container-forms-ord'>
            <div className={`colOrd-${ColumnsContainerOrderOrders ? ColumnsContainerOrderOrders : 6}`}>
              <Order onClickSave={handleClicSave} onClickCancel={onCancelClick} />
            </div>
            <div className={`colOrd-${ColumnsContainerPatientOrders ? ColumnsContainerPatientOrders : 6}`}>
              <Patient />
            </div>
          </div>
          <div className='dx-card details-card tab-panel-orders'>
            <Tabs dataSource={listsData} itemRender={renderTab} width={200} selectedIndex={selectedIndex} scrollByContent showNavButtons={false} onItemClick={onTabClick} />

            {selectedIndex === 0 && (
              <div className='detail-values-container'>
                <DataGrid className='grid' onRowUpdated={updateTotals} onRowRemoved={updateTotals} dataSource={itemsAdded} ref={dataGridRef} hoverStateEnabled={true} height='100%' repaintChangesOnly={true} highlightChanges={true} rowAlternationEnabled={true} showColumnLines={true}>
                  <Editing allowUpdating mode='cell' allowDeleting={mode === 'new' || mode == 'update'} />
                  <Toolbar>
                    <Item location='before'>
                      <PreorderStudiesSearchSelect dataSource={lstTarifas} onStudySelected={handleStudySelected} selectedStudies={addedStudiesAsItems} placeholder='Buscar estudios...' label='Estudios' disabled={mode === 'loading' || mode === 'view' || lstTarifas.length === 0} className='comboboxItems' />
                    </Item>

                    <Item location='after' locateInMenu='auto'>
                      <div className='separator' />
                    </Item>
                    <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
                      <div className='messages'>
                        <Button id='ApplyDisccount' icon={Disccount} text='Aplicar descuento' stylingMode='text' onClick={handleAddDiscount} />
                        {discount.type && discount.value && <div className='dx-badge'>{discount.type === 'percentage' ? `%` : `$`}</div>}
                        <Tooltip target={'#ApplyDisccount'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                          {discount.type && discount.value ? (discount.type === 'percentage' ? `${discount.value}% aplicado` : `${formatNumber(discount.value, { type: 'currency' })} aplicado`) : 'Aplicar un descuento'}
                        </Tooltip>
                      </div>
                    </Item>
                  </Toolbar>
                  <Column dataField='Estudio.Es_Codigo' allowEditing={false} caption='CÓDIGO' width={80} alignment='center' />
                  <Column dataField='Estudio.Es_Lr_Id' allowEditing={false} caption='LAB.REF' width={90} alignment='center' cellRender={renderLabRefChip} />
                  <Column dataField='Estudio.Es_Nombre' allowEditing={false} caption='ESTUDIO' minWidth={250} />
                  <Column dataField='Tf_Valor' caption='TARIFA' dataType='number' format='currency' width={120} minWidth={100} alignment='center' />
                </DataGrid>
                <div className='totals-summary'>
                  <div>
                    <strong>Subtotal: </strong>
                    <span>{formatNumber(totals.subtotal, { type: 'currency' })}</span>
                  </div>
                  <div>
                    <strong>Descuento: </strong>
                    <span>{formatNumber(totals.discount, { type: 'currency' })}</span>
                  </div>
                  <div>
                    <strong>Total: </strong>
                    <span>{formatNumber(totals.total, { type: 'currency' })}</span>
                  </div>
                </div>
              </div>
            )}
            {selectedIndex === 1 && <NotesPreorders data={currentNotes} updateNotes={updateNotes} />}
          </div>
        </div>
      </Popup>
      <Popup title='Agregar descuento' fullScreen={isSmall || isXSmall} width={400} height={'auto'} visible={modalDiscountVisible} onHiding={onCancelModalDiscountClick} onHidden={onCancelModalDiscountClick} showCloseButton={true}>
        <form action='#' onSubmit={hanAddDiscountConfirm}>
          <Form formData={discount} ref={frmRef}>
            <SimpleItem
              isRequired
              dataField='type'
              editorType='dxSelectBox'
              editorOptions={{
                showClearButton: true,
                items: [
                  { label: 'Porcentaje', value: 'percentage' },
                  { label: 'Valor fijo', value: 'value' },
                ],
                displayExpr: 'label',
                valueExpr: 'value',
              }}>
              <Label text='Tipo de descuento' />
            </SimpleItem>
            <SimpleItem isRequired dataField='value' editorType='dxNumberBox'>
              <Label text='Valor' />
            </SimpleItem>
            <ButtonItem buttonOptions={{ type: 'default', text: 'Aplicar', useSubmitBehavior: true }} />
          </Form>
        </form>
      </Popup>
    </div>
  );
};

export default Index;
